var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('employeesWithdrawals.createAWithdrawalProcess'),"description":_vm.$t('employeesWithdrawals.FromHereYouCanSetUpANewStaffWithdrawalProcess')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('employeesWithdrawals.SearchForAnOperation'),"emptyTableText":_vm.$t('employeesWithdrawals.ThereAreNoWithdrawals'),"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"buttonRole":_vm.$user.role.employees_withdrawals_add,"statusSearch":true,"statusValues":[
          { title: _vm.$t('orders.situation'), value: ''},
          { title: _vm.$t('orders.all'), value: ''},
          { title: _vm.$t('invoices.draft'), value: 0 },
          { title: _vm.$t('invoices.approved'), value: 1 } ],"cloumns":[
          { column: 'code', title: _vm.$t('employeesWithdrawals.Withdraw'), type: 'mainLink', sort: true },
          { column: 'employee_id', title: _vm.$t('employeesWithdrawals.EmployeesName'), to: 'employee', type: 'link', sort: true, link: true },
          {
            column: 'safe_id',
            title: _vm.$t('employeesWithdrawals.Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true,
          },
          { column: 'date', title: _vm.$t('employeesWithdrawals.date'), type: 'text', sort: true },
          {
            column: 'cost',
            title: _vm.$t('employeesWithdrawals.cost'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: _vm.$t('employeesWithdrawals.thatsAbout'),
            type: 'text',
            sort: true,
          },
          { column: 'notes', title: _vm.$t('employeesWithdrawals.note'), type: 'text', sort: true },
          {column: 'status', title: _vm.$t('bills.situation') ,type: 'status' , sort: true ,  values: [
              {title: _vm.$t('invoices.draft'), value: 0, color: 'dark'},
              {title: _vm.$t('invoices.approved'), value: 1, color: 'success'} ]
          },
          {
            column: 'options',
            title: _vm.$t('employeesWithdrawals.Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              {name: 'printEmployeesWithdrawal',   role: true},
              {
                name: 'edit',
                role: _vm.$user.admin || _vm.$user.role.employees_withdrawals_edit,
              },
              {name: 'file'},
              {
                name: 'delete',
                role: _vm.$user.admin || _vm.$user.role.employees_withdrawals_delete,
              } ],
          } ],"deleteText":{
          attention: _vm.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem:
            _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: _vm.$t('allerts.close'),
          confirm: _vm.$t('allerts.confirm'),
          loading: _vm.$t('allerts.loading'),
        }}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }